import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * Reusable block-with-confirm modal for VIN duplicate detection.
 *
 * Used by both create forms (Guard 2 — pre-submit) and the main job view
 * (Guard 3 — pre-invoice). States the conflict and requires an explicit confirm
 * to proceed; Cancel aborts the pending action.
 *
 * Deliberately does NOT itemize the conflicting requests. Listing them was
 * redundant — the operator already knows the vehicle's history, and the list
 * overflowed the modal body once a VIN accumulated more than one match. The
 * decision here is binary, so `intro` must carry the full picture on its own.
 *
 * Props:
 *   show         boolean
 *   title        header text
 *   intro        the sentence stating the conflict — the modal's only content,
 *                so it must be accurate for every state that triggers it
 *   confirmLabel text for the proceed button (e.g. "Create anyway")
 *   onConfirm    () => void   proceed with the acknowledged action
 *   onCancel     () => void   abort
 */
const DuplicateVinModal = ({
  show,
  title,
  intro,
  confirmLabel = "Create anyway",
  onConfirm,
  onCancel,
}) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="alert alert-warning mb-0">
        {intro}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="warning" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DuplicateVinModal;
